// src/pages/Dashboard/components/ProjectComparison.jsx
import React, { memo } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import ChartCard from "./ChartCard";

const CHART_HEIGHT = 350;

/**
 * Cross-project comparison bars. These always reflect the full filtered
 * data set so users can spot outliers across sites at a glance.
 */
function ProjectComparison({ comparisonData }) {
  return (
    <>
      <ChartCard title="Project Comparison — Manhours">
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <BarChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="project" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="manHours" fill="#2563eb" name="Man Hours" />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>

      <ChartCard title="Project Comparison — Manpower">
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <BarChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="project" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="manpower" fill="#10b981" name="Manpower" />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>

      <ChartCard title="Project Comparison — Incidents">
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <BarChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="project" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="lti" fill="#ef4444" name="LTI" />
            <Bar dataKey="nearMiss" fill="#f59e0b" name="Near Miss" />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>

      <ChartCard title="Project Comparison — Audits">
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <BarChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="project" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="audits" fill="#8b5cf6" name="Audits" />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
    </>
  );
}

export default memo(ProjectComparison);
